var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
